<template>
    <div class="container">
        <div class="max-w-md">
            <el-card class="bg-white">
                <div class="success-icon mb-6">
                    <el-button type="success" circle size="large">
                        <i class="el-icon-check"></i>
                    </el-button>
                </div>

                <h1 class="text-xl font-bold text-blue-600 mb-4">签到成功</h1>

                <div class="info-box mb-6 text-left">
                    <p class="mb-2"><span class="text-gray-500">姓名：</span>{{ name }}</p>
                    <p class="mb-2"><span class="text-gray-500">学工号：</span>{{ studentId }}</p>
                    <p><span class="text-gray-500">签到日期：</span>{{ date }}</p>
                    <p><span class="text-gray-500">签到时间：</span>{{ time }}</p>
                </div>
                <!-- <div class="btn-full">
                    <el-button type="primary" class="w-full" @click="goBack">
                        完成
                    </el-button>
                </div> -->
            </el-card>
        </div>
    </div>
</template>

<script>
export default {
    name: "check_in_success",
    data() {
        return {
            name: '',
            studentId: '',
            date: '',
            time: ''
        };
    },
    created() {
        // 获取路由参数
        this.name = this.$route.query.name || '未知';
        this.studentId = this.$route.query.studentId || '';
        this.date = this.$route.query.date;
        this.time = this.$route.query.time;
    },
    components: {},
    methods: {
        // goBack() {
        //     // 返回首页
        //     this.$router.push('/qrCode');
        // }
    },
};
</script>

<style lang="scss" scoped>
.container {
    width: 100%;
    height: 100%;
    display: flex;
    overflow: hidden;
    background: #eff6ff;
    justify-content: center;
    flex-direction: column;

    .text-xl {
        text-align: center;
        font-size: 25px;
        color: rgb(37 99 235);
    }

    .max-w-md {
        display: flex;
        flex-wrap: nowrap;
        flex-direction: column;
        justify-content: center;
        width: 90%;
        margin: 0 auto;
    }

    .text-gray {
        text-align: center;
        color: rgb(107 114 128);
    }

    .btn-full {
        text-align: center;

        .w-full {
            background: rgb(37, 99, 235);
            margin-top: 30px;
            width: 60%;
            height: 50px;
        }
    }


    .text-full {
        color: rgb(37, 99, 235);
        margin-top: 15px;
    }
}

/* 自定义样式 */
.el-card {
    border: none;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
}

.el-button {
    border-radius: 12px;
    padding: 12px 0;
    font-size: 16px;
}

.success-icon {
    display: flex;
    justify-content: center;
}

.success-icon .el-button {
    width: 60px;
    height: 60px;
    font-size: 30px;
}

.info-box {
    background-color: #f5f7fa;
    padding: 16px;
    border-radius: 8px;
}
</style>